import React from "react";

const SvgShapeCopy = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="currentColor"
    {...props}
  >
    <path
      fill="#091E42"
      fillRule="evenodd"
      d="M19.993 5.822a1.25 1.25 0 0 0 0-.19l-2-5a1 1 0 0 0-.999-.63H2.999a1 1 0 0 0-.93.63l-1.999 5a1.25 1.25 0 0 0 0 .19.58.58 0 0 0-.07.18 4 4 0 0 0 2 3.4V19a1 1 0 0 0 .999 1h13.995a1 1 0 0 0 1-1V9.441a4 4 0 0 0 1.999-3.44.58.58 0 0 0 0-.18zM10.996 18h-2v-4h2v4zm4.998 0h-2.999v-5a1 1 0 0 0-1-.999H7.998a1 1 0 0 0-1 1v5H4v-8a3.998 3.998 0 0 0 2.999-1.38 3.998 3.998 0 0 0 5.997 0 3.998 3.998 0 0 0 3 1.38v8zm0-9.999a2 2 0 0 1-1.999-2 1 1 0 1 0-2 0 2 2 0 1 1-3.998 0 1 1 0 1 0-2 0A2.001 2.001 0 1 1 2 6.152l1.68-4.149h12.635l1.68 4.15a2 2 0 0 1-2 1.85z"
    />
  </svg>
);

export default SvgShapeCopy;
